export const OAuthActions = {
  OAUTH_COMPLETE: 'OAUTH_COMPLETE',
  OAUTH_CANCELED: 'OAUTH_CANCELED',
  OAUTH_ERROR: 'OAUTH_ERROR',
  OAUTH_START: 'OAUTH_START',
  OAUTH_LOAD_USER: 'OAUTH_LOAD_USER',
  OAUTH_SAVE_TOKEN: 'OAUTH_SAVE_TOKEN',
  OAUTH_SIGNOUT: 'OAUTH_SIGNOUT'
};


// WEBPACK FOOTER //
// ./lib/redux-oauth2-actions.js